import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemList from '../../Item-List';
import { Kanban } from 'libs/kanban';

const Focus = ({
  id,
  name: initialName,
  setItems,
  index,
  isNew,
  setSelectedItem,
  setIsOpenModalDelete,
  setStatus,
}) => {
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [name, setName] = useState(initialName);

  const addFocus = async () => {
    const response = await seo.createTypeItem('focuses', { name });

    return {
      id: response.id,
      name,
      isNew: false,
    };
  };

  const updateFocus = async () => {
    return await seo.updateTypeItem('focuses', id, {
      id,
      name,
    });
  };

  return (
    <ItemList
      id={id}
      initialName={initialName}
      name={name}
      setName={setName}
      setItems={setItems}
      index={index}
      isNew={isNew}
      setSelectedItem={setSelectedItem}
      setIsOpenModalDelete={setIsOpenModalDelete}
      setStatus={setStatus}
      addItem={addFocus}
      updateItem={updateFocus}
      textSaveButton="Add focus"
    />
  );
};

Focus.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  setItems: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isNew: PropTypes.bool,
  setSelectedItem: PropTypes.func.isRequired,
  setIsOpenModalDelete: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default Focus;
